const PARAGRAPH_TAGS = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
		... on TagsListing {
			id
      uuid
      type
    }
  }
`;

export default PARAGRAPH_TAGS;
